'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbFullscreenDirective() {

    return {
        scope: true,
        selector: 'A',
        controller: 'cbFullscreenController',
        controllerAs: 'fullscreen',

        /* body overflow:hidden is removed to allow body scrolling when directive is destroyed, even while open*/
        link: function link(scope, element, attrs) {
            scope.$on('$destroy', function () {
                document.body.style.removeProperty('overflow');
            });
        }
    };
}

cbFullscreenDirective.$inject = [];

exports.default = cbFullscreenDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/fullscreen/cb-fullscreen.directive.js
// module id = 891
// module chunks = 0